/* eslint-disable no-param-reassign */

export default {
  namespaced: true,
  state: () => ({
    name: '',
    bundle: null,
  }),
  mutations: {
    set(state, payload) {
      state.name = payload.name;
      state.bundle = JSON.parse(JSON.stringify(payload.bundle));
    },
    unset(state) {
      state.name = '';
      state.bundle = null;
    },
  },
  actions: {
    set({
      commit,
    }, payload) {
      commit('set', payload);
    },
    unset({
      commit,
    }) {
      commit('unset');
    },
  },
  getters: {
    // name: (state) => state.name,
    // bundle: (state) => state.bundle,
    context: (state) => ({
      name: state.name,
      bundle: state.bundle,
    }),
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/context.js